<div class="card-image-container">
  <img
    *ngIf="mediaModel$ | async as mediaModel; else loadingSpinner"
    [class]="{
      'cover-img': !mediaModel.gif,
      'gif-img': !!mediaModel.gif
    }"
    [src]="getImgSrc(mediaModel)"
  />
  <ng-template #loadingSpinner>
    <mat-progress-spinner class="image-spinner" color="primary" mode="indeterminate" diameter="48" strokeWidth="5"></mat-progress-spinner>
  </ng-template>
</div>
